import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
	USER_ROLES.AGENT,
];

export default {
	TRANSLATIONS_AUDITING: {
		ACTIVE: true,
		NAME: 'manage-translations-auditing',
		LABEL: 'Translations',
		ICON: 'unbabel-translate',
		PATH: '/audits/:section',
		CHILDREN: ['TRANSLATIONS_AUDITING_HOME', 'TRANSLATIONS_AUDITING_CONVERSATION'],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},

	TRANSLATIONS_AUDITING_HOME: {
		ACTIVE: true,
		NAME: 'manage-translations-auditing-home',
		LABEL: 'Audits Home',
		PARAMS: {
			section: '',
		},
		PERMISSIONS,
	},
	TRANSLATIONS_AUDITING_CONVERSATION: {
		ACTIVE: true,
		NAME: 'manage-translations-auditing-conversation',
		LABEL: 'Audits Conversation',
		PARAMS: {
			section: ':id',
		},
		PERMISSIONS,
	},
};
